<div class="container" id="spinerLoader" *ngIf="loader">
    <div class="loader">Loading...</div>
</div>

<div mat-dialog-title class="modal-header header-radius-4">
    <div class="mx-3 d-flex justify-content-between align-items-center">
        <div>
            <h4 class="d-inline-block">Role Assignment</h4>
            <span *ngIf="spinnerLoader">
                <i class="fa fa-spin fa-spinner text-color-white ml-2"></i>
            </span>
        </div>
        <div>
            <button type="button" class="close close-btn" mat-dialog-close>
                <i class="fa fa-close"></i>
            </button>
        </div>
    </div>
</div>
<form id="addCustomer" name="assignForm" #assignForm="ngForm">

    <div class="modal-body">
        <div class="row">
            <div class="form-group col-lg-12">
                <label>Select Role</label>
                <div>
                    <br>
                    <div class="multirole-container text-bold float-right">
                        Default Role
                    </div>
                    <br>
                    <ng-container *ngFor="let role of roleList; let i = index">
                        <div class="multirole" id="role{{i}}">
                            <input type="checkbox" id="multiple-role-{{role.rolename}}" [value]="role.roleid"
                                name="selectedMultipleRole" (change)="selectMultipleRole($event)"
                                [checked]="assignedDefaultRole == role.roleid || assignedMultipleRoles.has(role.roleid) || (user.memberId == editRoleAssignmentPayload.memberDetail.memberId && user.role == role.rolename)"
                                [disabled]="assignedDefaultRole == role.roleid || disableAdminRoleSelectionForInvalidEmail(role) ||
                                (user.memberId == editRoleAssignmentPayload.memberDetail.memberId && user.role == role.rolename)">
                            {{ role.rolename }}
                            <input type="radio" id="default-role-{{role.rolename}}" class="float-right"
                                [value]="role.roleid" name="defaultRole" [(ngModel)]="assignedDefaultRole"
                                [ngClass]="disableAdminRoleSelectionForInvalidEmail(role) ? 'disable-radio' : ''"
                                [checked]="assignedDefaultRole == role.roleid">
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <button mat-dialog-close
            class="flat-butt flat-danger-butt flat-danger-grad-butt margin-right-10">Cancel</button>
        <button class="flat-butt flat-info-butt flat-info-grad-butt save-btn" (click)="reassignRole()">
            Save Changes
        </button>
    </div>

</form>